/* Onday - ajustements buy box + panier (08-09.10.26). Charge depuis layout/theme.liquid (defer). */

/* Buy box : formats toujours cliquables, saveur suivante automatique, badge qui vibre sur saveur indisponible,
   cadeaux masques avec la boite de 30 sticks si la case "Afficher avec la boite de 30 sticks" du bloc cadeau est decochee. */
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.onday-buybox');
  if (!wrapper) return;
  var picker = wrapper.querySelector('[data-onday-format-picker]');
  if (!picker) return;
  var formats = Array.prototype.slice.call(picker.querySelectorAll('[data-onday-format-option]'));
  var flavors = Array.prototype.slice.call(wrapper.querySelectorAll('[data-onday-flavor-option]'));
  var internalClick = false;

  function relax() {
    formats.forEach(function (o) {
      if (o.dataset.fullyOutOfStock === 'true') return;
      if (o.classList.contains('is-soldout')) o.classList.remove('is-soldout');
      o.removeAttribute('aria-disabled');
      var badge = o.querySelector('.onday-picker__soldout-badge');
      if (badge && badge.classList.contains('is-visible')) badge.classList.remove('is-visible');
    });
  }

  function syncFlavorBadges() {
    var selectedFormat = formats.filter(function (o) { return o.classList.contains('is-selected'); })[0];
    if (!selectedFormat) return;
    flavors.forEach(function (f, i) {
      if (f.classList.contains('is-soldout')) return;
      var badge = f.querySelector('.onday-picker__soldout-badge');
      if (!badge) return;
      var out = selectedFormat.dataset['stockF' + i] === 'false';
      if (badge.classList.contains('is-visible') !== out) badge.classList.toggle('is-visible', out);
    });
  }

  function syncGifts() {
    var selectedFormat = formats.filter(function (o) { return o.classList.contains('is-selected'); })[0];
    var isSticks = !!selectedFormat && /sticks/i.test(selectedFormat.dataset.productHandle || '');
    var gifts = wrapper.querySelectorAll('.onday-frequency-picker__gift[data-hide-with-sticks="true"]');
    for (var i = 0; i < gifts.length; i++) {
      var wanted = isSticks ? 'none' : '';
      if (gifts[i].style.display !== wanted) gifts[i].style.display = wanted;
    }
  }

  function sync() {
    relax();
    syncFlavorBadges();
    syncGifts();
  }

  sync();
  new MutationObserver(sync).observe(picker, { subtree: true, attributes: true });

  document.addEventListener('click', function (e) {
    if (internalClick) return;
    var flavor = e.target.closest ? e.target.closest('[data-onday-flavor-option]') : null;
    if (!flavor || !wrapper.contains(flavor)) return;
    if (flavor.classList.contains('is-soldout')) return;
    var badge = flavor.querySelector('.onday-picker__soldout-badge');
    if (!badge || !badge.classList.contains('is-visible')) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    badge.classList.remove('is-shaking');
    void badge.offsetWidth;
    badge.classList.add('is-shaking');
    badge.addEventListener('animationend', function () {
      badge.classList.remove('is-shaking');
    }, { once: true });
  }, true);

  document.addEventListener('click', function (e) {
    var option = e.target.closest ? e.target.closest('[data-onday-format-option]') : null;
    if (!option || !wrapper.contains(option)) return;
    if (option.classList.contains('is-selected')) return;
    var selectedFlavor = flavors.filter(function (f) { return f.classList.contains('is-selected'); })[0];
    var idx = flavors.indexOf(selectedFlavor);
    if (idx < 0) return;
    if (option.dataset['stockF' + idx] !== 'false') return;
    for (var i = 1; i < flavors.length; i++) {
      var j = (idx + i) % flavors.length;
      if (option.dataset['stockF' + j] === 'true' && !flavors[j].classList.contains('is-soldout')) {
        internalClick = true;
        flavors[j].click();
        internalClick = false;
        return;
      }
    }
  }, true);
});

/* Panier : on masque la ligne "Livraison - OFFERTE", puis le titre "Votre commande" s'il ne reste aucune ligne de detail. */
(function () {
  var scheduled = false;
  function hideFreeShippingRows() {
    scheduled = false;
    var labels = document.querySelectorAll('span.text-subdued');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (label.textContent.trim().toLowerCase() !== 'livraison') continue;
      var value = label.nextElementSibling;
      if (!value || !/offert/i.test(value.textContent)) continue;
      var row = label.parentElement;
      if (row && row.style.display !== 'none') row.style.display = 'none';
    }
    var titles = document.querySelectorAll('p.h6');
    for (var k = 0; k < titles.length; k++) {
      var title = titles[k];
      if (title.textContent.trim().toLowerCase() !== 'votre commande') continue;
      var box = title.parentElement;
      if (!box) continue;
      var hasDetails = Array.prototype.some.call(box.children, function (c) {
        return c !== title && c.style.display !== 'none' && c.textContent.trim() !== '';
      });
      var wanted = hasDetails ? '' : 'none';
      if (box.style.display !== wanted) box.style.display = wanted;
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(hideFreeShippingRows);
  }
  document.addEventListener('DOMContentLoaded', function () {
    hideFreeShippingRows();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();

/* Panier : message "Frais de livraison offerts des 60 euros en France et Belgique" au-dessus du Total quand le panier (EUR) est < 60 euros. */
(function () {
  var MESSAGE = 'Frais de livraison offerts dès 60€ en France et Belgique';
  var THRESHOLD_CENTS = 6000;
  var timer = null;
  var running = false;

  function findTotalRow() {
    var scope = document.querySelector('cart-drawer') || document.querySelector('.cart');
    if (!scope) return null;
    var all = scope.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length === 0 && el.textContent.trim() === 'Total' && el.parentElement) return el.parentElement;
    }
    return null;
  }

  function update() {
    if (running) return;
    running = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var show = cart.item_count > 0 && cart.currency === 'EUR' && cart.total_price < THRESHOLD_CENTS;
        var notes = document.querySelectorAll('.onday-cart-shipping-note');
        if (!show) {
          notes.forEach(function (n) { n.remove(); });
          return;
        }
        var row = findTotalRow();
        if (!row || !row.parentElement) return;
        var existing = row.previousElementSibling;
        if (existing && existing.classList.contains('onday-cart-shipping-note')) {
          notes.forEach(function (n) { if (n !== existing) n.remove(); });
          return;
        }
        notes.forEach(function (n) { n.remove(); });
        var note = document.createElement('p');
        note.className = 'onday-cart-shipping-note';
        note.textContent = MESSAGE;
        row.parentElement.insertBefore(note, row);
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(update, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    schedule();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.nodeType === 1 && t.closest && t.closest('cart-drawer, .cart')) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();